export default "__VITE_ASSET__e38ed080__"